/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Issue_Too_Many_Rows_PlInputs */

const en_statement_taxonomy_issue_too_many_rows_pl = /** @type {(inputs: Statement_Taxonomy_Issue_Too_Many_Rows_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many profit & loss rows`)
};

const nl_statement_taxonomy_issue_too_many_rows_pl = /** @type {(inputs: Statement_Taxonomy_Issue_Too_Many_Rows_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te veel W&V-regels`)
};

/**
* | output |
* | --- |
* | "Too many profit & loss rows" |
*
* @param {Statement_Taxonomy_Issue_Too_Many_Rows_PlInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_issue_too_many_rows_pl = /** @type {((inputs?: Statement_Taxonomy_Issue_Too_Many_Rows_PlInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Issue_Too_Many_Rows_PlInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_issue_too_many_rows_pl(inputs)
	return en_statement_taxonomy_issue_too_many_rows_pl(inputs)
});